import { render, staticRenderFns } from "./FishcarForm.vue?vue&type=template&id=5bad2435"
import script from "./FishcarForm.vue?vue&type=script&lang=js"
export * from "./FishcarForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports